import { Controller } from "@hotwired/stimulus"
import { sendMarketingEvent } from "../lib/marketing_events"

export default class extends Controller {
  static values = { events: Array }

  connect() {
    if (!this.hasEventsValue) return

    if (typeof window.gtag !== "function") {
      this.eventsValue.forEach((conversion) => {
        this.record("ad_conversion_dispatch_unavailable", conversion, "gtag_unavailable")
      })
      return
    }

    this.eventsValue.forEach((conversion) => this.send(conversion))
  }

  send(conversion) {
    if (!conversion.event_name || !conversion.send_to || !conversion.transaction_id) return

    const storageKey = `munibot:google-ads:${conversion.send_to}:${conversion.transaction_id}`
    if (this.wasSent(storageKey)) {
      this.record("ad_conversion_suppressed", conversion, "local_duplicate")
      return
    }

    const payload = {
      send_to: conversion.send_to,
      transaction_id: conversion.transaction_id,
      event_timeout: 2500,
      event_callback: () => this.record("ad_conversion_callback", conversion)
    }
    if (conversion.value != null) payload.value = conversion.value
    if (conversion.currency) payload.currency = conversion.currency

    window.gtag("event", "conversion", payload)
    this.markSent(storageKey)
    this.record("ad_conversion_dispatched", conversion)
  }

  wasSent(storageKey) {
    try {
      return Boolean(localStorage.getItem(storageKey))
    } catch {
      return false
    }
  }

  markSent(storageKey) {
    try {
      localStorage.setItem(storageKey, "1")
    } catch {
      // Storage can be unavailable in private browsing; conversion dispatch still proceeds.
    }
  }

  record(name, conversion, reason = null) {
    sendMarketingEvent(name, {
      conversion_event: conversion.event_name,
      transaction_id: conversion.transaction_id,
      reason: reason
    })
  }
}
